import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconStableVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStableVoice"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M7.5 10V14" stroke="currentColor"/><Path d="M10.5 7V17" stroke="currentColor"/><Path d="M13.5 9V15" stroke="currentColor"/><Path d="M16.5 10V14" stroke="currentColor"/></CentralIconBase>;
});

export default IconStableVoice;
